define.alias("shared/components/shared/emoji-textarea", "calendar/components/shared/emoji-textarea");